module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/thanks-34.vue");


//////////////////
// WEBPACK FOOTER
// ./en/about/thanks.md
// module id = 477
// module chunks = 399